import {Product} from './Product';
import {VatRateService} from '../../services/vat-rate.service';
import {ContractItemTransfer} from './ContractItemTransfer';
import {ContractItemType} from './ContractItemType';
import {ContractItem} from './ContractItem';

export class TextContractItem extends ContractItem {

    name = 'Textová položka';
    type: ContractItemType = ContractItemType.text;
}



// WEBPACK FOOTER //
// /app/src/model/Entities/TextContractItem.ts